import styles from "./paymentDomainScreenBackground.module.scss";

/** Домен «платежи» — отдельная тема при необходимости (пока совпадает с базовым доменным слоем) */
export function PaymentDomainScreenBackground() {
  return <div className={styles.root} aria-hidden />;
}
